import {
    Card,
    CardContent,
    CardActions,
    Box,
    Skeleton
} from '@mui/material';

export function DealCardSkeleton({ showTimeTypography = true }) {
    return (
        <Card sx={{
            maxWidth: 345,
            height: 'fit-content',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 4,
        }}>
            {/* Image/Carousel Area */}
            <Box sx={{ position: 'relative' }}>
                <Skeleton variant="rectangular" width="100%" height={200} />
            </Box>

            {/* Content Area */}
            <CardContent sx={{ padding: '0px 16px', flexGrow: 1 }}>
                {/* Title */}
                <Skeleton variant="text" width="80%" height={32} sx={{ mb: 1 }} />

                {/* Restaurant Name */}
                <Skeleton variant="text" width="60%" height={24} sx={{ mb: 1 }} />

                {/* Price */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <Skeleton variant="text" width={80} height={28} />
                    <Skeleton variant="text" width={60} height={20} />
                    <Skeleton variant="rectangular" width={70} height={20} sx={{ borderRadius: 1 }} />
                </Box>

                {/* Time and Days */}
                <Skeleton variant="rectangular" width="70%" height={32} sx={{ borderRadius: 2 }} />
            </CardContent>

            {/* Actions Area */}
            <CardActions sx={{ mt: 'auto', pt: 1 }}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                }}>
                    {/* Rating Chip */}
                    <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 3 }} />

                    {/* Like and Share Buttons */}
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 2 }} />
                        <Skeleton variant="circular" width={32} height={32} />
                    </Box>
                </Box>
            </CardActions>
        </Card>
    );
}